import { StorageDataType } from './types/storageTypes';

export function encode(value: string) {
  return btoa(encodeURIComponent(value));
}

export function decode(value: string) {
  return decodeURIComponent(window?.atob(value));
}

export function stringifyValue(value: StorageDataType) {
  return typeof value === 'string' ? value : JSON.stringify(value);
}

export function parseValue(value: string) {
  try {
    const newValue = JSON.parse(`${value}`);
    return newValue;
  } catch {
    return value;
  }
}
